import { computed } from 'vue';
import { useRoute } from 'vue-router';
import type { LocationQuery } from 'vue-router';
import {
  isComponentCachingDisabled,
  isPageCachingDisabled,
} from '~~/helpers/caching/cachingQueryParams';

type QueryRecord = Record<string, string | string[] | undefined | null>;

function toPlainQuery(query: LocationQuery): QueryRecord {

  const result: QueryRecord = {};

  for (const key of Object.keys(query)) {

    const value = query[key];

    if (value === undefined || value === null) {

      continue;

    }

    if (Array.isArray(value)) {

      result[key] = value.filter((item): item is string => typeof item === 'string');
      continue;

    }

    result[key] = value;

  }

  return result;

}

export function useCachingQueryParams() {

  const route = useRoute();

  const componentCachingDisabled = computed(() =>
    isComponentCachingDisabled(toPlainQuery(route?.query ?? {})),
  );

  const pageCachingDisabled = computed(() =>
    isPageCachingDisabled(toPlainQuery(route?.query ?? {})),
  );

  return {
    componentCachingDisabled,
    pageCachingDisabled,
  };

}
